import {
  CLOSE_NETWORK_CREATE_POPUP,
  CREATE_NETWORK_FULFILLED,
  GET_NETWORKS_FULFILLED,
  NetworkActionTypes,
  NetworkState,
  OPEN_NETWORK_CREATE_POPUP,
  SET_NETWORK_LOADING,
} from './network.types';

export const initialState: NetworkState = {
  entities: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function networkReducer(
  state = initialState,
  action: NetworkActionTypes,
): NetworkState {
  switch (action.type) {
    case GET_NETWORKS_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data || [],
      };

    case CREATE_NETWORK_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case OPEN_NETWORK_CREATE_POPUP:
      return {
        ...state,
        single: action.payload.network ?? null,
        createdId: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: true,
        },
      };

    case CLOSE_NETWORK_CREATE_POPUP:
      return {
        ...state,
        ui: {
          ...state.ui,
          isCreatePopupOpen: false,
        },
      };

    case SET_NETWORK_LOADING:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
